import {
  Component,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  order_model,
  Payment_Data,
  PaymentSuccessResult
} from 'src/app/models/basket';
import { TraceClassDecorator } from '@sentry/angular';
import { PackagesData } from 'src/app/models/package';
import { ApiResult } from 'src/app/models/PromiseResult';
import { PackagesService } from 'src/app/services/packages.service';
import { PaymentComponent } from '../../shared/payment/payment.component';
import { name_input, URLS } from './../../../constant/constant';
import { Router } from '@angular/router';
import { PatientService } from 'src/app/services/patient.service';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

enum PAYMENT_FORMS_TABS {
  PACKAGE_FORM = 0,
  PAYMENT_FORMS = 1,
  PAYMENT_SUCCESS = 2
}

@TraceClassDecorator()
@Component({
  selector: 'app-membership-plan',
  templateUrl: './membership-plan.component.html',
  styleUrls: [
    './membership-plan.component.css',
    '../../../../assets/css/custom-egd.css'
  ]
})
export class MembershipPlanComponent implements OnInit {
  @ViewChild(PaymentComponent) payment_screen: PaymentComponent;

  readonly name_input: RegExp = name_input;

  packagesData: PackagesData = new PackagesData(0, 2);

  basicvisible: boolean = false;
  basicplusvisible: boolean = false;
  provisible: boolean = false;
  ispackageselected: boolean = false;
  slug: string = "";
  is_uk_country: boolean = false;
  is_primary_provider: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly packagesService: PackagesService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly patientService: PatientService,
    private readonly utilitiesService: UtilitiesService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef,
    private readonly providerstateService: ProviderStateService

  ) {

  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    if(URLS.IS_UK)
    {
      this.is_uk_country = true;
    }
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
      { label: 'Packages' }
    ]);
    // const hasReloaded = localStorage.getItem('hasReloaded');
    // if (!hasReloaded) {
    //   // Mark that the page has been reloaded
    //   localStorage.setItem('hasReloaded', 'true');
    //   // Reload the page
    //   window.location.reload();
    // } else {
    //   // Clear the flag after the first reload
    //   localStorage.removeItem('hasReloaded');
    // }
    this.changeDetector.detectChanges();
    await this.findPackageStatus();
  }

  async findPackageStatus() {
    this.packagesData.packages_list_api_result = new ApiResult(true);
    await this.packagesService
      .status()
      .toPromise()
      .then((result) => {
        this.packagesData.packages_list_api_result.PromiseResult = result;
        if (result.success) {
          this.packagesData.packages_india =
            result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR;
          this.packagesData.packages_usa_india =
            result.data.packages_groups.USA_TRAVELLING_PACKAGES_INR;
          this.packagesData.package_status = result.data.status;
          // if (this.packagesData.packages_india.length > 0) {
          //   this.selectPackage(this.packagesData.packages_india[0].id); // by default selected the lowest one
          // }
          // if (this.packagesData.packages_usa_india.length > 0) {
          //   this.selectPackage(this.packagesData.packages_usa_india[0].id); // by default selected the lowest one
          // }
        }
        this.packagesData.packages_list_api_result.Posting = false;
        this.packagesData.package_status.forEach((status) => {
          status.user_package_count = status.user_package_count.filter(
            (packageCount) => packageCount.current_count > 0
          );
        });
      })
      .catch((error: HttpErrorResponse) => {
        this.packagesData.packages_list_api_result.ServerError = error.error;
        this.packagesData.packages_list_api_result.PromiseResult.success =
          false;
        this.packagesData.packages_list_api_result.Posting = false;
      });
  }

  async submitPackages() {
    this.packagesData.packages_submit_api_result = new ApiResult(true);
    this.packagesData.paymentData.payment_start_api_result = new ApiResult(
      true
    );
    this.packagesData.paymentData = new Payment_Data();
    let selectedPackages;
    if (this.packagesData.selected_packages.package_id) {
      selectedPackages = this.packagesData.selected_packages
    }
    else if (this.packagesData.selected_package_travelling.package_id) {
      selectedPackages = this.packagesData.selected_package_travelling;
    }
    await this.packagesService
      .purchase(selectedPackages)
      .toPromise()
      .then(async (result) => {
        this.packagesData.packages_submit_api_result.PromiseResult = result;
        this.packagesData.paymentData.payment_start_api_result.PromiseResult =
          result;
        if (result.success) {
          const order: order_model = result.data;

          this.packagesData.paymentData.order_data = order;
          await this.start_payment();
        }
        this.packagesData.paymentData.payment_start_api_result.Posting = false;
        this.packagesData.packages_submit_api_result.Posting = false;
      })
      .catch((error) => {
        this.packagesData.packages_submit_api_result.ServerError = error.error;
        this.packagesData.packages_submit_api_result.PromiseResult.success =
          false;
        this.packagesData.packages_submit_api_result.Posting = false;
        this.packagesData.paymentData.payment_start_api_result.ServerError =
          error.error;
        this.packagesData.paymentData.payment_start_api_result.PromiseResult.success =
          false;
        this.packagesData.paymentData.payment_start_api_result.Posting = false;
      });
  }

  async openInvoice() {
    this.packagesData.print_data.api_result = new ApiResult(true);
    this.packagesData.print_data.displayModal = true;
    await this.patientService
      .fetchInvoice(
        this.packagesData.paymentData.paymentSuccessData.consultationData
          .transaction_id
      )
      .toPromise()
      .then((result) => {
        this.packagesData.print_data.api_result.PromiseResult = result;
        if (result.success) {
          this.packagesData.print_data.data = result.data;
        } else {
          this.packagesData.print_data.api_result.ErrorModel = result.error;
        }
        this.packagesData.print_data.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.packagesData.print_data.api_result.ServerError = error.error;
        this.packagesData.print_data.api_result.PromiseResult.success = false;
        this.packagesData.print_data.api_result.Posting = false;
      });
  }

  async start_payment() {
    this.changeDetector.detectChanges(); // Ensure change detection is triggered
    await this.payment_screen.load_payment_gateway();
  }

  onPaymentSuccess(data: PaymentSuccessResult) {
    this.packagesData.paymentData.paymentSuccessData = data;
    this.packagesData.tabview_Data.nextTab();
  }

  async nextTab() {
    switch (this.packagesData.tabview_Data.selected_tab) {
      case PAYMENT_FORMS_TABS.PACKAGE_FORM:
        await this.submitPackages();
        this.packagesData.tabview_Data.nextTab();
        break;
      default:
        break;
    }
  }

  async prevTab() {
    this.packagesData.tabview_Data.prevTab();
  }

  RouterNavigation(path: string) {
    this.router.navigate(['/' + this.slug + '/patient/' + path]);
  }

  print() {
    window.print();
  }

  isPosting(): boolean {
    return (
      this.packagesData.packages_list_api_result.Posting ||
      this.packagesData.packages_submit_api_result.Posting || this.packagesData.paymentData.transaction_submit_api_result.Posting
    );
  }

  selectPackage(package_id: string): void {
    if (this.packagesData.selected_packages.package_id === package_id) {
      // If the package is already selected, deselect it
      this.packagesData.selected_packages.package_id = "";
    } else {
      // Otherwise, select the package
      this.packagesData.selected_packages.package_id = package_id;
      this.packagesData.selected_package_travelling.package_id = "";
    }
    this.changeDetector.detectChanges(); // Ensure Angular detects the changes
  }

  isCurrentPackageSelected(package_id: string): boolean {
    return this.packagesData.selected_packages.package_id === package_id;
  }



  selectPackageTravelling(package_id: string): void {
    if (this.packagesData.selected_package_travelling.package_id === package_id) {
      // If the package is already selected, deselect it
      this.packagesData.selected_package_travelling.package_id = "";
    } else {
      // Otherwise, select the package
      this.packagesData.selected_package_travelling.package_id = package_id;
      this.packagesData.selected_packages.package_id = "";
    }
    this.changeDetector.detectChanges(); // Ensure Angular detects the changes
  }

  isCurrentPackageSelectedTravelling(package_id: string): boolean {
    return this.packagesData.selected_package_travelling.package_id === package_id;
  }



  async openLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }

  onDialogShow() {
    setTimeout(() => {
      const body = document.body;
      body.classList.remove('ui-overflow-hidden');
      const bodyClasses = body.classList;
    }, 100);
  }

  openbasicfunction() {
    this.basicvisible = true;
    this.onDialogShow();
  }

  openbasicplusfunction() {
    this.basicplusvisible = true;
    this.onDialogShow();
  }

  openprofunction() {
    this.provisible = true;
    this.onDialogShow();
  }
}
